<template>
  <div>
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane label="Alarm" name="1">
        <el-table size="mini" :data="alarms" style="width: 100%;box-sizing: border-box;" @row-dblclick="alarm_db_click" max-height="240">
          <el-table-column prop="DeviceName" label="Device" width="100"></el-table-column>
          <el-table-column prop="ContainerName" label="Container" width="100"></el-table-column>
          <el-table-column prop="RcvTime" width="130" label="Time"> </el-table-column>
          <el-table-column prop="AlarmInfo" label="Alarm Info" show-overflow-tooltip> </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="Log" name="2">
        <el-table size="mini" :data="logs" style="width: 100%;box-sizing: border-box;" max-height="240">
          <el-table-column prop="RcvTime" label="Time" width="130"></el-table-column>
          <el-table-column prop="ContainerName" label="Container Name" width="120"></el-table-column>
          <el-table-column prop="LogInfo" label="Log" show-overflow-tooltip> </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  props: {
    alarms: {
      type: Array,
      default: () => ([])
    },
    logs: {
      type: Array,
      default: () => ([])
    }
  },
  data() {
    return {
      activeName: '1'
    }
  },
  methods: {
    alarm_db_click(row, e) {
      console.log('alarm_db_click', row)
      this.$emit('alarm-click', row.SN, e)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>




// WEBPACK FOOTER //
// src/views/home/alarm/alarm.vue